import React from "react";
import { intlShape } from "@ai360/core/intl";
import { messages } from "../i18n-messages";
import { TextInput, Section, SubSection, Checkbox } from "~/core";
import "./component.css";
import { useIntl } from "react-intl";

const API_URL = "apiUrl";

interface IAgvanceIntegrationAliasList {
    apiUrl?: string;
    databaseId?: string;
    isAgvanceCustomerExists?: string;
    linkedProductOnly?: string;
    removeProperCasing?: string;
    requireCustomerSearchFlag?: string;
    userId?: string;
    userPassword?: string;
}

interface IAgvanceIntegrationProps {
    aliasList: IAgvanceIntegrationAliasList;
    // Optional: formatMessage comes from useIntl(), and no caller passes intl.
    intl?: intlShape;
    isAgvancePersonality?: boolean;
    isEditMode?: boolean;
    onTextChange: (formKey: string, value: string | boolean, callback?: () => void) => void;
    record: Record<string, any>;
}

const AgvanceIntegration = (props: IAgvanceIntegrationProps): React.ReactElement => {
    const { formatMessage } = useIntl();
    const { aliasList, isAgvancePersonality, isEditMode, onTextChange, record } = props;
    return (
        <Section
            headerText={formatMessage(messages.agvanceIntegration)}
            className="agvance-integration"
        >
            {!(API_URL in aliasList) ? null : (
                <TextInput
                    placeholderText={formatMessage(messages.apiUrl)}
                    maxLength={400}
                    onChange={(value) => onTextChange(aliasList[API_URL], value)}
                    value={record[aliasList[API_URL]]}
                    containerClassNames={["text-input-stretch"]}
                />
            )}
            <SubSection>
                <TextInput
                    placeholderText={formatMessage(messages.databaseId)}
                    maxLength={50}
                    onChange={(value) => onTextChange(aliasList.databaseId, value)}
                    value={record[aliasList.databaseId]}
                    disabled={isEditMode && record[aliasList.isAgvanceCustomerExists]}
                />
                {!isAgvancePersonality ? (
                    <Checkbox
                        label={formatMessage(messages.requireCustomerSearch)}
                        onChange={(e, value) =>
                            onTextChange(aliasList.requireCustomerSearchFlag, value)
                        }
                        value={record[aliasList.requireCustomerSearchFlag]}
                    />
                ) : null}
                {!isAgvancePersonality ? null : (
                    <TextInput
                        placeholderText={formatMessage(messages.userId)}
                        maxLength={50}
                        onChange={(value) => onTextChange(aliasList.userId, value)}
                        value={record[aliasList.userId]}
                    />
                )}
            </SubSection>
            {!isAgvancePersonality ? null : (
                <SubSection className="agvance-integration-checkbox-cont">
                    <TextInput
                        placeholderText={formatMessage(messages.userPassword)}
                        maxLength={100}
                        password
                        onChange={(value) => onTextChange(aliasList.userPassword, value)}
                        value={record[aliasList.userPassword]}
                        containerClassNames={["text-input-stretch"]}
                    />
                    {!aliasList.requireCustomerSearchFlag ? null : (
                        <Checkbox
                            label={formatMessage(messages.requireCustomerSearch)}
                            onChange={(e, value) =>
                                onTextChange(aliasList.requireCustomerSearchFlag, value)
                            }
                            value={record[aliasList.requireCustomerSearchFlag]}
                        />
                    )}
                </SubSection>
            )}
            {!isAgvancePersonality ||
            !(aliasList.removeProperCasing || aliasList.linkedProductOnly) ? null : (
                <SubSection className="agvance-integration-checkbox-cont">
                    {!aliasList.removeProperCasing ? null : (
                        <Checkbox
                            label={formatMessage(messages.removeProperCasing)}
                            onChange={(e, value) =>
                                onTextChange(aliasList.removeProperCasing, value)
                            }
                            value={record[aliasList.removeProperCasing]}
                        />
                    )}
                    {!aliasList.linkedProductOnly ? null : (
                        <Checkbox
                            label={formatMessage(messages.linkedProductOnly)}
                            onChange={(e, value) =>
                                onTextChange(aliasList.linkedProductOnly, value)
                            }
                            value={record[aliasList.linkedProductOnly]}
                        />
                    )}
                </SubSection>
            )}
        </Section>
    );
};

export default AgvanceIntegration;
